import React from "react";
import ImagePlaceholder from "assets/placeholders/profile-image.png";
import classNames from "classnames";
import { UserContentImage } from "components/images";

const ProfileImage = ({ image, onClick, className }) => (
  <div className={classNames("profile-image", className)} onClick={onClick}>
    <UserContentImage src={image} placeholder={ImagePlaceholder} circular />
  </div>
);

export default ProfileImage;
